import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { GAME_DEFS, GameDef } from './games.data';

/**
 * The Toolbox "Games" gallery — a premium dark panel of game cards. Picking one
 * emits {@link play}; the Toolbox opens it as a floating window. Ported from the
 * OTA-B2B-6 design (games.jsx GamesGallery + games-art.jsx card illustrations).
 * Default (Emulated) encapsulation keeps the `gm-*` styles scoped.
 */
@Component({
  selector: 'app-games-gallery',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './games-gallery.component.html',
  styleUrl: './games-gallery.component.scss',
})
export class GamesGalleryComponent {
  readonly games = GAME_DEFS;
  @Output() readonly play = new EventEmitter<GameDef>();

  // Precomputed grid coordinates for the card illustrations (templates can't do
  // integer division), matching the design's GameArt layouts.
  readonly msRects = Array.from({ length: 20 }, (_, i) => ({ x: 20 + (i % 5) * 17, y: 12 + Math.floor(i / 5) * 15 }));
  readonly chRects = Array.from({ length: 16 }, (_, i) => {
    const r = Math.floor(i / 4), c = i % 4;
    return { x: 38 + c * 12, y: 12 + r * 12, dark: (r + c) % 2 === 1 };
  });
  readonly c4Circles = Array.from({ length: 20 }, (_, i) => ({ cx: 44 + (i % 4) * 11, cy: 19 + Math.floor(i / 4) * 11 }));
  readonly numTop = [{ v: 3, cx: 20 }, { v: 7, cx: 44 }, { v: 6, cx: 68 }, { v: 4, cx: 92 }];
}
